import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Button, Input, Select, Alert, message as antdMessage } from 'antd';
import '../../assets/css/contactus.css';
import { validateEmail } from '../../assets/js/validators';
import { apiGetPage, apiAddInfo, apiGetCustom } from '../../request/api'

const { TextArea } = Input;

interface contactInfo {
    contactUs: string;
    ourEmail: string;
    name: string;
    surName: string;
    companyName: string;
    contactEmail: string;
    tallUs: string;
    chooseType: string;
    buttonTxt: string;
    emailError: string;
    shouldIn: string;
    remindUs: string;
}

interface companyType {
    value: string;
    label: string;
}

const HomePart4: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);

    // 状态管理每个输入字段
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [messageText, setMessageText] = useState(''); // 重命名为 messageText
    const [selectedOption, setSelectedOption] = useState(null);
    const [companyTypeList, setCompanyTypeList] = useState<companyType[]>([]);
    const [loading, setLoading] = useState(false);
    
    const DEFAULT_BG = '#e5e5ee';
    const FILLED_BG = '#ffffff';
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [lang, setLang] = useState<'zh' | 'en'>('zh');

    // 错误状态
    const [companyNameError, setCompanyNameError] = useState<string | null>(null);
    const [emailError, setEmailError] = useState<string | null>(null);
    const [messageError, setMessageError] = useState<string | null>(null);
    const [contactInfo, setConteactInfo] = useState<contactInfo>({
        contactUs: "",
        ourEmail: "",
        name: "",
        surName: "",
        companyName: "",
        contactEmail: "",
        tallUs: "",
        chooseType: "",
        buttonTxt: "",
        emailError: "",
        shouldIn: "",
        remindUs: "",
    });

    useEffect(() => {
            const code = localStorage.getItem('siteLanguage') || 'zh';
            setLang(code === 'en' ? 'en' : 'zh');
        }, []);


    const text = {
        zh: {
            title: '服务邮箱',
            knowMore: '提交',
            MorMor: '提交中',
        },
        en: {
            title: 'Service Email',
            knowMore: 'Submit',
            MorMor: 'Loading',
        }
    };
    const t = text[lang]

    const handleChange = (
        setter: React.Dispatch<React.SetStateAction<string>>,
        errorSetter: React.Dispatch<React.SetStateAction<string | null>>,
        value: string,
        isEmail?: boolean
    ) => {
        setter(value);
        if (!isEmail && value.trim() !== '') {
            errorSetter(null);
        }
    };

    useEffect(() => {
        apiGetCustom({
            pageId: '887EB9E23DF64D4AB167F8DD317692C5',
            languageCode,
            size: 100
        }).then((res) => {
            const data = res.data.data;

            const newContactInfo: Partial<contactInfo> = {};
            let companyTypesRaw = '';

            data.forEach((item: any) => {
                switch (item.code) {
                    case 'contactTitle':
                        newContactInfo.contactUs = item.value;
                        break;
                    case 'serviceEmail':
                        newContactInfo.ourEmail = item.value;
                        break;
                    case 'inputName':
                        newContactInfo.name = item.value;
                        break;
                    case 'inputSex':
                        newContactInfo.surName = item.value;
                        break;
                    case 'inputCompanyName':
                        newContactInfo.companyName = item.value;
                        break;
                    case 'inputEmail':
                        newContactInfo.contactEmail = item.value;
                        break;
                    case 'inputUrNeed':
                        newContactInfo.tallUs = item.value;
                        break;
                    case 'plaseChoose':
                        newContactInfo.chooseType = item.value;
                        break;
                    case 'remindUs':
                        newContactInfo.shouldIn = item.value;
                        break;
                    case 'companyType':
                        companyTypesRaw = item.value;
                        break;
                    case 'remindUs':
                        newContactInfo.remindUs = item.value;
                        break;
                    case 'pageTitle':
                    case 'pageURL':
                    default:
                        break;
                }
            });

            setConteactInfo(prev => ({
                ...prev,
                ...newContactInfo,
                emailError: '请输入有效的邮箱',
            }));

            if (companyTypesRaw) {
                const options = companyTypesRaw.split(',').map((type: string) => ({
                    value: type.trim(),
                    label: type.trim(),
                }));
                setCompanyTypeList(options);
            }
        });
    }, []);

    // 清空表单
    const resetForm = () => {
        setFirstName('');
        setLastName('');
        setCompanyName('');
        setEmail('');
        setMessageText('');
        setSelectedOption(null);
        setCompanyNameError(null);
        setEmailError(null);
        setMessageError(null);
    };

    const sendContent = () => {
        let hasError = false;

        if (!validateEmail(email)) {
            setEmailError(contactInfo.emailError);
            hasError = true;
        } else {
            setEmailError(null);
        }

        if (messageText.trim() === '') {
            setMessageError(contactInfo.shouldIn);
            hasError = true;
        } else {
            setMessageError(null);
        }

        if (hasError) return;

        setLoading(true);

       apiAddInfo({
    tid: '24B25EC7990E426299F0DE3D8670393D',
    name: firstName,
    surName: lastName,
    contactEmail: email,
    companyName: companyName,
    companyType: selectedOption,
    messageDetail: messageText,
    uploadTime: getUploadTime(),   // ← 添加上传时间
}).then(res => {
            setLoading(false);
            
            if (res.data.ret !== '0') {
                // 上传失败 - 显示错误提示
                antdMessage.error({
                    content: '提交失败，请稍后重试',
                    duration: 3,
                    style: {
                        marginTop: '50vh',
                    },
                });
            } else {
                // 上传成功 - 显示成功提示并清空表单
                antdMessage.success({
                    content: '提交成功！我们会尽快与您联系',
                    duration: 3,
                    style: {
                        marginTop: '50vh',
                    },
                });
                resetForm();
            }
        }).catch(err => {
            setLoading(false);
            // 网络错误或其他错误
            antdMessage.error({
                content: '网络错误，请检查网络连接后重试',
                duration: 3,
                style: {
                    marginTop: '50vh',
                },
            });
        });
    };
    const getUploadTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hour}:${minute}`;
};

    return (
        <div className="home-part4">
            <div className='home-part4_header1'>{contactInfo.contactUs || '联络我们'}</div>
            <div className='home-part4_header2'>{t.title}:naier@nextook.net</div>
            
            <div className='home-part4_input_box'>
                <div className='home-part4_input_box_left'>
                    <Input
                        placeholder={contactInfo.name}
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        style={{
                            backgroundColor: firstName.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />

                    <Input
                        placeholder={contactInfo.surName}
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        style={{
                            backgroundColor: lastName.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />

                    <Input
                        placeholder={contactInfo.companyName}
                        value={companyName}
                        onChange={(e) => handleChange(setCompanyName, setCompanyNameError, e.target.value)}
                        status={companyNameError ? 'error' : ''}
                        style={{
                            backgroundColor: companyName.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />

                    {companyNameError && <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>{companyNameError}</div>}
{/* 
                    <Select
                        value={selectedOption}
                        style={{ width: 528, fontSize: '18px' }}
                        onChange={setSelectedOption}
                        allowClear
                        className={selectedOption ? 'selected-state' : ''}
                        placeholder={contactInfo.chooseType}
                        options={companyTypeList.length > 0 ? companyTypeList : [{ value: '', label: 'Loading...' }]}
                    /> */}

                    <Input
                        placeholder={contactInfo.contactEmail}
                        value={email}
                        onChange={(e) => handleChange(setEmail, setEmailError, e.target.value, true)}
                        status={emailError ? 'error' : ''}
                        style={{
                            backgroundColor: email.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />
                    {emailError && <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>{emailError}</div>}
                </div>
                <div className='home-part4_input_box_right'>
                    <TextArea
                        className='testarea-tent'
                        rows={4}
                        placeholder={contactInfo.tallUs}
                        value={messageText}
                        style={{
                            height:'337px',
                            backgroundColor: messageText.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                        onChange={(e) => {
                            setMessageText(e.target.value);
                            if (e.target.value.trim() === '') {
                                setMessageError(contactInfo.shouldIn);
                            } else {
                                setMessageError(null);
                            }
                        }}
                        status={messageError ? 'error' : ''}
                    />
                    {messageError && <div style={{ color: '#e60d0d', marginTop: '3px', fontSize: '12px', marginLeft: '144px' }}>{messageError}</div>}
                </div>
            </div>

            <div className='part4-button'>
                <button 
                    className='contactus-button' 
                    style={{ 
                        background: '#ac9455', 
                        boxShadow: 'none',
                        opacity: loading ? 0.6 : 1,
                        cursor: loading ? 'not-allowed' : 'pointer'
                    }} 
                    onClick={sendContent}
                    disabled={loading}
                >
                    
                    {loading ? t.MorMor : (contactInfo.buttonTxt || t.knowMore)}
                </button>
            </div>
        </div>
    );
};

export default HomePart4;